import React from 'react';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';

export default function HotelInfoReviews({ reviews }) {
  return reviews.map((review, idx) => {
    const {
      name,
      rate,
      reviewdate,
      traveltime,
      content,
      reviewtime,
      positive,
      negative,
    } = review;
    let rating = [];
    for (let i = 0; i < rate; i++) {
      rating.push(<AiFillStar key={`instar-${i}`} className="hotel__star" />);
    }
    for (let i = rate; i < 5; i++) {
      rating.push(<AiOutlineStar key={`outstar-${i}`} className="hotel__star" />);
    }
    return (
      <div className="review" key={reviewtime + idx}>
        <div className="review__top-container">
          <div className="review__author">
            <b>{name ? name : 'Анонимный отзыв'}</b>
          </div>
          <div className="review__rating">{rating}</div>
          <div className="review__date">Дата отзыва: {reviewdate}</div>
          {traveltime ? (
            <div className="review__traveltime">
              Период поездки: {traveltime}
            </div>
          ) : null}
        </div>
        {positive ? (
          <div className="review__text">Плюсы: {positive}</div>
        ) : null}
        {negative ? (
          <div className="review__text">Минусы: {negative}</div>
        ) : null}
        {content ? <div className="review__text">{content}</div> : null}
      </div>
    );
  });
}
